<script>
    import { User } from "sveltefire";
</script>

<style>
    main {
        grid-area: gallery;
        background-color: var(--dark-brown);
        color: var(--white);
        padding: 1em;
    }
</style>

<main>
    <User let:user>
        Signed in as {user.displayName}
    </User>
</main>
